import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { VenueMenu } from "sweet-global";
import OutlineButton from "sweet-web/components/universal/Button/OutlineButton";
import Input from "sweet-web/components/universal/Input";
import FileInput from "sweet-web/components/universal/Input/FileInput";
import { Indent } from "sweet-web/components/universal/View";
import { RootState } from "sweet-web/redux";

const Inputs = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-end;
  margin: 10px 0;
`;

const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin: 10px 0;
`;

const emptyMenu = (type: "FOOD" | "DRINK"): VenueMenu => ({
  type,
  name: "",
  file: null
});

type Props = {
  type: "DRINK" | "FOOD";
  menuId?: string;
  menuEntity?: VenueMenu;
  onSave: (space: VenueMenu) => void;
  onCancel: () => void;
};

const EditMenu: React.FC<Props> = props => {
  const [menu, setMenu] = useState(
    props.menuEntity ? props.menuEntity : emptyMenu(props.type)
  );

  useEffect(() => {
    if (props.menuEntity) setMenu(props.menuEntity);
  }, [props.menuEntity]);

  return (
    <Indent>
      <Inputs>
        <Input
          style={{ padding: 0 }}
          title="Menu Name"
          value={menu.name}
          onChange={value => {
            setMenu(m => ({
              ...m,
              name: value
            }));
          }}
        />
        <FileInput
          style={{ marginLeft: 10 }}
          value={menu.file}
          onChange={value => {
            setMenu(m => ({
              ...m,
              file: value
            }));
          }}
        />
      </Inputs>
      <Buttons>
        <OutlineButton
          title="Save"
          style={{ marginRight: 10 }}
          onClick={() => {
            setMenu(emptyMenu(props.type));
            props.onSave(menu);
          }}
        />
        <OutlineButton
          title="Cancel"
          color="gray"
          onClick={() => {
            setMenu(emptyMenu(props.type));
            props.onCancel();
          }}
        />
      </Buttons>
    </Indent>
  );
};

export default EditMenu;
